var exports = {
  "X7": "UserProfileBadges.module__containerModal___ZHFUZX",
  "j4": "UserProfileBadges.module__containerModalMobile___ZHFUZX",
  "pP": "UserProfileBadges.module__containerModalDesktop___ZHFUZX",
  "bZ": "UserProfileBadges.module__largeProfile___ZHFUZX",
  "RS": "UserProfileBadges.module__containerPopout___ZHFUZX",
  "Qk": "UserProfileBadges.module__badgeMobile___ZHFUZX",
  "EJ": "UserProfileBadges.module__badgeDesktop___ZHFUZX",
  "qS": "UserProfileBadges.module__badge___ZHFUZX",
  "X8": "UserProfileBadges.module__sequenceBadge___ZHFUZX",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___ZHFUZX",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___ZHFUZX",
  "nf": "UserProfileBadges.module__link___ZHFUZX",
  "$J": "UserProfileBadges.module__linkButton___ZHFUZX",
};

module.exports = exports;
